import { TriangleAlert } from "lucide-react";

import { ConfirmationModal } from "@components/ConfirmationModal";

type NavigationWarningModalProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  /**
   * When a recording is in progress the warning explains that leaving will
   * stop and discard it, rather than the generic unsaved-changes copy (MDRS-85).
   */
  isRecording?: boolean;
};

const NavigationWarningModal = ({
  isOpen,
  onConfirm,
  onCancel,
  isRecording = false,
}: NavigationWarningModalProps) => {
  return (
    <ConfirmationModal
      open={isOpen}
      type="warning"
      icon={<TriangleAlert className="size-10 text-destructive" />}
      title={
        isRecording ? "Recording in progress" : "You are about to navigate away"
      }
      description={
        isRecording
          ? "A recording is still in progress. If you leave now, the recording will be stopped and discarded. Do you wish to continue?"
          : "If you proceed, you will lose all unsaved changes. Do you wish to continue?"
      }
      confirmButtonText="Yes, Leave"
      cancelButtonText="Go Back"
      onConfirm={onConfirm}
      onCancel={onCancel}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
    />
  );
};

export default NavigationWarningModal;
